<template>
  <div class="about">
    <h1 class="animate__animated animate__backInDown">A site for goods</h1>
  </div>
</template>
